// extracted by mini-css-extract-plugin
export default {"chooseForMe":"TY6NV4"};